import { ApolloError, gql, useMutation } from "@apollo/client";
import { GET_EMPLOYEE_TIMESHEETS_AND_ASSIGNMENTS_WEEKLY } from "hooks";
import { useCallback } from "react";
import { toast } from "react-toastify";
import { TimeRange, Timesheet } from "types/timesheets";

type UpdateTimesheetsReadyToReviewVars = {
  workLogs: Pick<Timesheet, "id">[];
};

type UdateTimesheetsReadyToReviewData = {
  updatedTimesheets: { result: Timesheet[] };
};

const UPDATE_TIMESHEETS_READY_TO_REVIEW = gql`
  mutation updateTimesheetsReadyToReview($workLogs: [WorkLogInputType]!) {
    updatedTimesheets: ready_to_review(work_logs: $workLogs) {
      result {
        id
        startTime: start_time
        readyToReview: ready_to_review
      }
    }
  }
`;

interface Props {
  employeeId: string;
  activeWeek: TimeRange;
}

export const useUpdateTimesheetsReadyToReview = ({
  employeeId,
  activeWeek,
}: Props) => {
  const { start: weekStart, end: weekEnd } = activeWeek;

  const [mutateTimesheetsReadyToReview] = useMutation<
    UdateTimesheetsReadyToReviewData,
    UpdateTimesheetsReadyToReviewVars
  >(UPDATE_TIMESHEETS_READY_TO_REVIEW, {
    refetchQueries: [
      {
        query: GET_EMPLOYEE_TIMESHEETS_AND_ASSIGNMENTS_WEEKLY,
        variables: {
          startDate: weekStart,
          endDate: weekEnd,
          contractStartDate: weekStart,
          contractEndDate: weekStart,
          exceptionsStartDate: weekStart,
          exceptionsEndDate: weekEnd,
          employeeId,
          isManager: false,
        },
      },
    ],
  });

  const updateTimesheetsReadyToReview = useCallback(
    async (timesheets: Pick<Timesheet, "id">[]) => {
      try {
        await mutateTimesheetsReadyToReview({
          variables: { workLogs: timesheets },
        });
      } catch (ex) {
        toast.error((ex as ApolloError)?.message);
      }
    },
    [mutateTimesheetsReadyToReview]
  );

  return { updateTimesheetsReadyToReview };
};
